import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextareaComponent } from './textarea.component';
import { TextareaDirective } from './textarea.directive';
import { FormsModule } from '@angular/forms';
import { IconModule } from '../icon/icon.module';
import { LabelModule } from '../label/label.module';
import { MessageModule } from '../message/message.module';
import { StackModule } from '../stack/stack.module';

@NgModule({
  declarations: [TextareaComponent, TextareaDirective],
  imports: [CommonModule, FormsModule, IconModule, LabelModule, MessageModule, StackModule],
  exports: [TextareaComponent, TextareaDirective],
  schemas: [NO_ERRORS_SCHEMA],
})
export class TextareaModule {}
